"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Attachment/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _fileSize = require('shared/utils/fileSize');



var _previewSupport = require('shared/utils/previewSupport');
var _MediaTile = require('web/components/Conversation/Message/FileMessage/MediaTile'); var _MediaTile2 = _interopRequireDefault(_MediaTile);
var _useFileOpener = require('web/components/Conversation/Message/FileMessage/useFileOpener'); var _useFileOpener2 = _interopRequireDefault(_useFileOpener);
var _FileVideo = require('web/components/Conversation/Message/FileMessage/FileVideo'); var _FileVideo2 = _interopRequireDefault(_FileVideo);

var _Error = require('./Error'); var _Error2 = _interopRequireDefault(_Error);
var _File = require('./File'); var _File2 = _interopRequireDefault(_File);
var _Image = require('./Image'); var _Image2 = _interopRequireDefault(_Image);
















const Attachment = ({
  FileKey,
  FileName,
  Size,
  Mime = '',
  BlurHash,
  ImageWidth,
  ImageHeight,
  ThumbnailURL,
  DurationMs,
  Error,
  small,
  fetchLinks,
}) => {
  const { openFile, fallbackNode } = _useFileOpener2.default.call(void 0, )

  if (Error) {
    return _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Error2.default, { FileName: FileName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}} )
      , fallbackNode
    )
  }

  const requestLinks = () => FileKey
    ? fetchLinks().catch(() => null)
    : Promise.resolve(null)
  const requestOriginal = () => requestLinks().then(response => _optionalChain([response, 'optionalAccess', _ => _.Link]) || null)
  const requestFreshThumbnail = () => requestLinks().then(response => _optionalChain([response, 'optionalAccess', _2 => _2.ThumbnailLink]) || null)
  const openOriginal = () => openFile(requestOriginal)
  const mediaKind = _previewSupport.getMimeFirstMediaKind.call(void 0, Mime, FileName)

  if (mediaKind === 'image') {
    const renderDerivative = _previewSupport.shouldRenderImageDerivative.call(void 0, {
      blurHash: BlurHash,
      imageWidth: ImageWidth,
      imageHeight: ImageHeight,
      thumbnailUrl: ThumbnailURL,
    })
    const attachment = renderDerivative
      ? _react2.default.createElement(_Image2.default, {
          key: FileKey,
          blurHash: BlurHash,
          thumbnailUrl: ThumbnailURL,
          width: ImageWidth,
          height: ImageHeight,
          fileName: FileName,
          onRequestFreshThumbnail: requestFreshThumbnail,
          onRequestOriginal: requestOriginal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
        )
      : _react2.default.createElement(_MediaTile2.default, { kind: "image", fileName: FileName, onClick: openOriginal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}} )
    return _react2.default.createElement(_react2.default.Fragment, null, attachment, fallbackNode)
  }

  if (mediaKind === 'video') {
    const renderDerivative = _previewSupport.shouldRenderImageDerivative.call(void 0, {
      blurHash: BlurHash,
      imageWidth: ImageWidth,
      imageHeight: ImageHeight,
      thumbnailUrl: ThumbnailURL,
    })
    const attachment = renderDerivative
      ? _react2.default.createElement(_FileVideo2.default, {
          key: FileKey,
          blurHash: BlurHash,
          thumbnailUrl: ThumbnailURL,
          imageWidth: ImageWidth,
          imageHeight: ImageHeight,
          fileName: FileName,
          durationMs: DurationMs,
          onRequestFreshThumbnail: requestFreshThumbnail,
          onRequestOriginal: requestOriginal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
        )
      : _react2.default.createElement(_MediaTile2.default, { kind: "video", fileName: FileName, onClick: openOriginal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}} )
    return _react2.default.createElement(_react2.default.Fragment, null, attachment, fallbackNode)
  }

  return _react2.default.createElement(_react2.default.Fragment, null
    , _react2.default.createElement(_File2.default, {
      onClick: openOriginal,
      fileName: FileName,
      fileSize: _fileSize.getDisplaySize.call(void 0, Size),
      small: small, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
    )
    , fallbackNode
  )
}

exports. default = Attachment
